/**
 * Helps managing a consistent cursor in HTML input elements.
 */
export class Cursor {
    private textBeforeStart = "";
    private textAfterEnd = "";
    private selectionStart: number;
    private selectionEnd: number;

    input: HTMLInputElement;

    /**
     * Saves the state of cursor related properties.
     * Call this method before you apply changes to the input value.
     */
    store() {
        if (!this.input) {
            return;
        }

        this.selectionStart = this.input.selectionStart;
        this.selectionEnd = this.input.selectionEnd;

        const value = this.input.value;
        this.textBeforeStart = value.substring(0, this.selectionStart);
        this.textAfterEnd = value.substring(this.selectionEnd);
    }

    /**
     * Places the cursor in a user-friendly way.
     */
    restore() {
        if (!this.input) {
            return;
        }

        const value = this.input.value;
        let cursor = value.length;

        if (value.endsWith(this.textAfterEnd)) {
            cursor = value.length - this.textAfterEnd.length;
        } else if (value.startsWith(this.textBeforeStart)) {
            cursor = this.textBeforeStart.length;
        } else {
            const beforeLastChar = this.textBeforeStart[this.selectionStart - 1];
            const newIndex = value.indexOf(beforeLastChar, this.selectionStart - 1);
            if (newIndex !== -1) {
                cursor = newIndex + 1;
            }
        }

        this.input.setSelectionRange(cursor, cursor);
    }
}
